<div
    class="bounding-box"
    [style.width.em]="getEmWidth()"
    [style.height.em]="getEmHeight()"
    [style.border]="isShowBoundingBox() ? '1px dashed #000' : '1px solid transparent'"
    style="vertical-align: center;"
>
  <div
    *ngIf="element._isUploadingImage && !element.diagram"
    class="upload-info-text"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
    <span class="sr-only">{{ getText('sr_static_diagram_uploading') }}</span>
    <span aria-hidden="true">Uploading Image...</span>
  </div>
  <render-image 
    *ngIf="element.diagram" 
    [element]="element.diagram"
    [style.opacity]="element._isEditingBoundingBox ? '0.3' : '1'"
  ></render-image>
</div>
